export const COR_ID_POR_HEX: Record<string, string> = {
  '#94a3b8': 'cinza', '#f1f5f9': 'branco', '#1e293b': 'preto', '#ef4444': 'vermelho',
  '#3b82f6': 'azul', '#22c55e': 'verde', '#eab308': 'amarelo', '#f97316': 'laranja',
}

export function corIdDeHex(hex?: string | null): string {
  return COR_ID_POR_HEX[(hex || '').toLowerCase()] || 'cinza'
}

/** URL do PNG 3D já pintado na cor escolhida e girado para a direção (passos de 15 graus). */
export function urlIcone3d(iconId: string, hex?: string | null, direcao = 0): string {
  const tipo = iconId.replace(/^v3d_/, '')
  const cor = corIdDeHex(hex)
  const grau = (((Math.round((direcao || 0) / 15) * 15) % 360) + 360) % 360
  return `/vehicle-icons/3d/${tipo}/${cor}/${tipo}_${cor}_${String(grau).padStart(3, '0')}.png`
}
